export const hasRole = (userRoles: string[], role: string): boolean => {
  return userRoles.includes(role);
};

export const hasAnyRole = (userRoles: string[], roles: string[]): boolean => {
  return roles.some((role) => userRoles.includes(role));
};
